import { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import type { RanchAlert } from '@shared/ranch-feed';

/**
 * Official alerts from the Babcock Ranch resident portal Alert Center.
 *
 * These are the town's own channel — boil-water notices, road and amenity
 * closures, storm operations — and are distinct from the National Weather
 * Service alert that arrives on the weather payload. Both can be live at
 * once during a storm, and they say different things: NWS describes the
 * weather, the town describes what it is doing about it.
 *
 * Failure is silent by design. An empty alert list is the normal, good
 * state, so a fetch error should look the same as "nothing to report"
 * rather than putting a scary error card on the home screen.
 */
export function useRanchAlerts() {
  const [alerts, setAlerts] = useState<RanchAlert[]>([]);

  useEffect(() => {
    let cancelled = false;
    api
      .get<{ alerts: RanchAlert[] }>('/community/alerts')
      .then((res) => {
        if (!cancelled) setAlerts(res.alerts ?? []);
      })
      .catch(() => {
        if (!cancelled) setAlerts([]);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { alerts };
}
